import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PhoneFrame } from '../PhoneMockups';
import { AppleIcon, GooglePlayIcon } from '../StoreIcons';
import { APP_STORE_URL, PLAY_STORE_URL, openStore } from '../appLinks';

export function ForArtists() {
  const navigate = useNavigate();

  return (
    <>
      <div className="page-hero">
        <div className="ph-text">
          <p className="s-eyebrow">For Artists</p>
          <h1 className="hero-h1" style={{ fontSize: 'clamp(44px,5vw,72px)', marginBottom: 24 }}>Your music career,<br /><em>all in one profile.</em></h1>
          <p className="s-body" style={{ marginBottom: 36 }}>Get discovered, find paid work, collaborate, and get paid — on a platform built for music professionals, not just another social feed.</p>
          <div className="cta-actions">
            <button className="btn btn-primary btn-lg" onClick={() => navigate('/redirect')}>Get the app</button>
          </div>
        </div>
        <div className="ph-phone">
          <PhoneFrame style={{ width: 260, height: 540 }} screen="profile" frameWidth={260} />
        </div>
      </div>

      <div className="s-bg1" id="page-features">
        <div className="s-wrap">
          <div className="fcards">
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><circle cx="14" cy="8" r="5" /><path d="M5 24a9 9 0 0118 0" /><path d="M10 15l4 5 4-5" /></svg>
              <div className="fcard-title">A profile that works as hard as you do</div>
              <div className="fcard-body">Your tracks, videos, credits, and skills in one professional portfolio. Verified credits mean your work is recognised — and your reputation follows you everywhere.</div>
            </div>
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7" /><line x1="22" y1="22" x2="16" y2="16" /><line x1="8" y1="11" x2="14" y2="11" /><line x1="11" y1="8" x2="11" y2="14" /></svg>
              <div className="fcard-title">Find work, not just followers</div>
              <div className="fcard-body">Browse and apply to paid gigs, session work, bookings, and collaborations posted by artists, organizations, event planners, and listeners across India.</div>
            </div>
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="14" r="4" /><circle cx="20" cy="8" r="4" /><circle cx="20" cy="20" r="4" /><line x1="12" y1="12" x2="16" y2="10" /><line x1="12" y1="16" x2="16" y2="18" /></svg>
              <div className="fcard-title">Collaborate with the right people</div>
              <div className="fcard-body">Find producers, session players, vocalists, and bandmates by genre, skill, and location. Form bands, build a shared profile, and manage projects together.</div>
            </div>
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="6" width="20" height="16" rx="2" /><line x1="4" y1="12" x2="24" y2="12" /><circle cx="14" cy="19" r="2" /></svg>
              <div className="fcard-title">Get paid, safely</div>
              <div className="fcard-body">Agree terms, deliver your work, and get paid through escrow-protected payments — so every deal is protected on both sides, every time.</div>
            </div>
          </div>
        </div>
      </div>

      <section className="s-bg4 cta-strip">
        <h2 className="s-h2">Ready to build your career?</h2>
        <p className="s-body">Join a growing community of music professionals building their careers on Tarana.</p>

        <div className="app-badges">
          <div className="app-badge" onClick={() => openStore(APP_STORE_URL)}>
            <AppleIcon />
            <div className="app-badge-text"><span className="app-badge-sub">Download on the</span><span className="app-badge-name">App Store</span></div>
          </div>
          <div className="app-badge" onClick={() => openStore(PLAY_STORE_URL)}>
            <GooglePlayIcon className="app-badge-play-icon" />
            <div className="app-badge-text"><span className="app-badge-sub">Get it on</span><span className="app-badge-name">Google Play</span></div>
          </div>
        </div>
      </section>
    </>
  );
}
